import PdfModalContainer from './PdfModalContainer';

export default PdfModalContainer;
